/** InsCoder 2026-02-06 B + Scroll spy combined with sticky buy button **/

class ScrollspyBuyArea extends HTMLElement {
  constructor() {
    super();
    this.addToCartButton = this.querySelector('[data-scrollspy-add-to-cart]');
    this.priceContainer = this.querySelector('[data-scrollspy-price]');
    this.mediaContainer = this.querySelector('[data-scrollspy-product-media]');
    this.btnText = this.querySelector('.btn-text[data-scrollspy-btn-text]');
  }

  connectedCallback() {
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', this.onAddToCart.bind(this));
    }

    this.onVariantChangedBound = this.onVariantChanged.bind(this);
    document.addEventListener('variant:change', this.onVariantChangedBound);

    // 监听 pageshow 事件，恢复按钮状态
    this.resetButtonBound = this.resetButton.bind(this);
    window.addEventListener('pageshow', this.resetButtonBound);

    // 使用 MutationObserver 监听 product-form 按钮的 aria-busy 属性变化
    this.setupFormButtonObserver();
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this.onVariantChangedBound);
    window.removeEventListener('pageshow', this.resetButtonBound);
    if (this.formButtonObserver) {
      this.formButtonObserver.disconnect();
    }
  }

  setupFormButtonObserver() {
    if (!this.productForm) return;

    var formSubmitButton = this.productForm.querySelector('button[type="submit"]');
    if (!formSubmitButton) return;

    this.formButtonObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-busy') {
          if (!mutation.target.hasAttribute('aria-busy')) {
            this.resetButton();
          }
        }
      }.bind(this));
    }.bind(this));

    this.formButtonObserver.observe(formSubmitButton, { attributes: true });
  }

  resetButton() {
    if (this.addToCartButton) {
      this.addToCartButton.removeAttribute('aria-busy');
    }
  }

  get productForm() {
    return this._productForm = this._productForm || document.querySelector('form[is="product-form"]');
  }

  onAddToCart(event) {
    event.preventDefault();

    if (!this.addToCartButton || this.addToCartButton.disabled) return;

    if (this.productForm) {
      this.addToCartButton.setAttribute('aria-busy', 'true');
      this.productForm.requestSubmit();
      return;
    }

    var variantId = this.addToCartButton.getAttribute('data-variant-id');
    if (!variantId) return;

    this.addToCartButton.setAttribute('disabled', '');
    this.addToCartButton.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (error) {
        console.error('ScrollspyBuyArea:', error);
      })
      .finally(function () {
        this.addToCartButton.removeAttribute('disabled');
        this.addToCartButton.removeAttribute('aria-busy');
      }.bind(this));
  }

  onVariantChanged(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    this.updateButton(variant);
    this.updatePrice(variant);
    this.updateMedia(variant);
  }

  updateButton(variant) {
    if (!this.addToCartButton) return;

    this.addToCartButton.setAttribute('data-variant-id', variant.id);

    if (variant.available) {
      this.addToCartButton.removeAttribute('disabled');
      if (this.btnText) {
        this.btnText.textContent = (typeof theme !== 'undefined' && theme.variantStrings)
          ? theme.variantStrings.addToCart
          : 'ADD TO CART';
      }
    } else {
      this.addToCartButton.setAttribute('disabled', '');
      if (this.btnText) {
        this.btnText.textContent = (typeof theme !== 'undefined' && theme.variantStrings)
          ? theme.variantStrings.soldOut
          : 'SOLD OUT';
      }
    }
  }

  updatePrice(variant) {
    if (!this.priceContainer) return;

    var formatMoney = function (cents) {
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        var format = theme.settings.currencyCodeEnabled
          ? theme.settings.moneyWithCurrencyFormat
          : theme.settings.moneyFormat;
        return theme.Currency.formatMoney(cents, format);
      }
      return '$' + (cents / 100).toFixed(2);
    };

    var priceHTML = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceHTML =
        '<span class="scrollspy-buy-area__price-sale">' + formatMoney(variant.price) + '</span>' +
        '<span class="scrollspy-buy-area__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
    } else {
      priceHTML = '<span class="scrollspy-buy-area__price-regular">' + formatMoney(variant.price) + '</span>';
    }

    this.priceContainer.innerHTML = priceHTML;
  }

  updateMedia(variant) {
    if (!this.mediaContainer || !variant.featured_media) return;

    var image = this.mediaContainer.querySelector('img');
    if (!image) return;

    var newImage = new Image();
    newImage.alt = variant.featured_media.alt || '';
    newImage.src = variant.featured_media.preview_image.src;

    var widthsAttr = this.mediaContainer.getAttribute('data-widths');
    var widths = widthsAttr ? widthsAttr.split(',').map(function (w) { return parseInt(w); }) : [60, 120];
    var srcset = widths
      .filter(function (w) { return w <= variant.featured_media.preview_image.width; })
      .map(function (w) { return variant.featured_media.preview_image.src + '&width=' + w + ' ' + w + 'w'; })
      .join(', ');

    newImage.srcset = srcset;
    newImage.sizes = image.sizes;

    this.mediaContainer.replaceChildren(newImage);
  }
}

customElements.define('scrollspy-buy-area', ScrollspyBuyArea);

/** InsCoder 2026-02-06 E + Scroll spy combined with sticky buy button **/

/**  2026-02-14 B + Fixed toggle when product form hits top **/
(function() {
  var sections = document.querySelectorAll('.cust-scroll-spy');
  var productFormWrapper = document.querySelector('.product-form-wrapper');
  if (!productFormWrapper || !sections || sections.length === 0) return;

  var ticking = false;
  function update() {
    ticking = false;
    var top = productFormWrapper.getBoundingClientRect().top;
    var shouldFix = top <= 0;
    sections.forEach(function(section) {
      if (shouldFix) {
        section.classList.add('fixed');
      } else {
        section.classList.remove('fixed');
      }
    });
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
/**  2026-02-14 E + Fixed toggle when product form hits top **/
